import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=523696dc&"
import script from "./Policy.vue?vue&type=script&lang=js&"
export * from "./Policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('523696dc')) {
      api.createRecord('523696dc', component.options)
    } else {
      api.reload('523696dc', component.options)
    }
    module.hot.accept("./Policy.vue?vue&type=template&id=523696dc&", function () {
      api.rerender('523696dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Leads/Tabs/Policy.vue"
export default component.exports